import Modal from "react-modal";
import { useState } from "react";
import { useDispatch } from "react-redux";

import { getGetAssetListingStatisticsThunk } from "../../../../Thunks";
import { Loading } from "../../../../Components";
import styles from "../statistics.module.css";

const customStyles = {
  content: {
    minHeight: "550px",
    width: "673px",
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    right: "auto",
    bottom: "auto",
    padding: "0",
    border: "none",
    backgroundColor: "#f0f0f3",
    borderRadius: "24px",
    padding: "32px 0 35px 40px",
    lineHeight: "0",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    zIndex: 1000,
  },
};

const KPI_FIELDS_MAP = {
  Maturity: "projectMaturityParameter",
  "Project Risk": "smartContractPlatformSecurityAuditLevel",
  "Historical Risk": "projectSecurityLevel",
  "AML Activities": "amlLevel",
  Lawsuits: "lawsuitsLevel",
};

export const ModalKpi = ({ open, onClose, filters, setFilters }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isValidationError, setIsValidationError] = useState(false);
  const { enteredValue, negativeChange, positiveChange, selectedFields } =
    filters;
  const toggleField = (field) => {
    setFilters((prev) => ({
      ...prev,
      selectedFields: prev.selectedFields.includes(field)
        ? prev.selectedFields.filter((f) => f !== field)
        : [...prev.selectedFields, field],
    }));
  };

  const setNegativeChangeValue = (val) => {
    setFilters((prev) => ({
      ...prev,
      negativeChange: val,
      positiveChange: val ? false : prev.positiveChange,
    }));
  };

  const setPositiveChangeValue = (val) => {
    setFilters((prev) => ({
      ...prev,
      positiveChange: val,
      negativeChange: val ? false : prev.negativeChange,
    }));
  };

  const trendChange = negativeChange ? "lower" : positiveChange ? "higher" : "";

  const acceptClick = () => {
    setIsValidationError(false);
    setLoading(true);

    dispatch(
      getGetAssetListingStatisticsThunk({
        searchValue: enteredValue,
        trendChange,
        trendFields: selectedFields,
      }),
    ).finally(() => {
      setLoading(false);
      onClose();
    });
  };

  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <div className="listing_asset_modal_head">
        <h2 className="listing_asset_modal_title">Parameters were changed</h2>
        <i
          className="icon-close listing_modal_close_icon"
          onClick={onClose}
          style={{ cursor: "pointer" }}
        />
      </div>
      <div className={styles.modalTopWrapper}>
        <div className="listing_change_alert_wrapper" style={{ width: "40%" }}>
          <input
            type="checkbox"
            checked={negativeChange}
            onChange={() => setNegativeChangeValue(!negativeChange)}
            className="listing_change_alert_checkbox"
          />
          <span className={styles.redTriangle}></span>
          <span className={styles.topLabel}>Negative change</span>
        </div>

        <div className="listing_change_alert_wrapper" style={{ width: "40%" }}>
          <input
            type="checkbox"
            checked={positiveChange}
            onChange={() => setPositiveChangeValue(!positiveChange)}
            className="listing_change_alert_checkbox"
          />
          <span className={styles.greenTriangle}></span>
          <span className={styles.topLabel}>Positive change</span>
        </div>
      </div>
      <div className={styles.modalbottomWrapper}>
        {Object.entries(KPI_FIELDS_MAP).map(([label, field]) => (
          <div key={field} className="listing_change_alert_wrapper">
            <input
              type="checkbox"
              checked={selectedFields.includes(field)}
              onChange={() => toggleField(field)}
              className="listing_change_alert_checkbox"
            />
            <span className={styles.topLabel}>{label}</span>
          </div>
        ))}
      </div>

      <div className="listing_modal_submit_wrapper">
        <button
          onClick={acceptClick}
          className="listing_modal_submit"
          style={{ width: "120px" }}
        >
          ACCEPT {loading && <Loading />}
        </button>
      </div>
    </Modal>
  );
};
